var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-add"},[_c('AppFileDragDrop',{on:{"error":_vm.showErrors},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}}),_c('div',{staticClass:"file-add__actions"},[_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.submitFiles}},[_vm._v(" Dodaj pliki ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }